
import React from 'react';

const GooglePrivacyPolicyAndServiceTerm = () => {
    return (
        <div>
            <p
                className={'m-0 pb-2 text-center'}>This site is protected by reCAPTCHA and the Google <a
                    href={'https://policies.google.com/privacy'}>Privacy Policy</a> and <a
                    href={'https://policies.google.com/terms'}>Terms of Service</a> apply.
            </p>
        </div>
    );
};

export default GooglePrivacyPolicyAndServiceTerm;